import { useBranding, logoLogin } from '../context/BrandingContext';
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { KeyRound, Eye, EyeOff } from 'lucide-react';
import toast from 'react-hot-toast';
import { authAPI } from '../services/api';

const RedefinirSenha = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { branding } = useBranding();

  const [novaSenha, setNovaSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    if (novaSenha.length < 6) {
      setErro('A senha deve ter no mínimo 6 caracteres.');
      return;
    }
    if (novaSenha !== confirmar) {
      setErro('As senhas não conferem.');
      return;
    }
    setLoading(true);
    try {
      await authAPI.redefinirSenha(token, novaSenha);
      toast.success('Senha redefinida. Entre com a nova senha.');
      navigate('/login');
    } catch (error) {
      setErro(error.response?.data?.detail || 'Não foi possível redefinir a senha. O link pode ter expirado. Solicite um novo.');
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src={logoLogin(branding)}
          alt={branding.nome}
          style={{ height: '80px', marginBottom: '1rem', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
        />
        <p style={{ textAlign: 'center', color: 'var(--gray-600)', marginBottom: '1.5rem' }}>Criar nova senha</p>

        {erro && <div className="alert alert-error">{erro}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="novaSenha">Nova senha</label>
            <div style={{ position: 'relative' }}>
              <input
                type={show ? 'text' : 'password'}
                id="novaSenha"
                className="form-control"
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                placeholder="Mínimo 6 caracteres"
                required
                style={{ paddingRight: '40px' }}
              />
              <button
                type="button"
                onClick={() => setShow(!show)}
                style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray-500)', padding: '4px', display: 'flex', alignItems: 'center' }}
                title={show ? 'Ocultar senha' : 'Mostrar senha'}
              >
                {show ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="confirmar">Confirmar nova senha</label>
            <input
              type={show ? 'text' : 'password'}
              id="confirmar"
              className="form-control"
              value={confirmar}
              onChange={(e) => setConfirmar(e.target.value)}
              placeholder="Repita a senha"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Salvando...' : (<><KeyRound size={18} /> Redefinir senha</>)}
          </button>

          <div style={{ textAlign: 'center', marginTop: '0.85rem' }}>
            <button
              type="button"
              onClick={() => navigate('/login')}
              style={{ background: 'none', border: 'none', color: 'var(--gray-600)', cursor: 'pointer', fontSize: '0.88rem', padding: 0 }}
            >
              Voltar ao login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RedefinirSenha;
